import logo from "./logo.svg";
import "./App.css";
import { memo, useEffect } from "react";
import { getUser, isLogin } from "./Store/Actions/AuthAction";
import { AuthMiddleware } from "./Store/Middlewares/AuthMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { router } from "./routes";
import Loading from "./components/loadingComp/Loading";
import AlertComp from "./components/alert/Alert";
import { notification } from "antd";
import { hideAlert } from "./Store/Actions/GeneralActions";
import { ThemeProvider } from "./utills/ThemeContext";
import { TimezoneProvider } from "./utills/TimezoneContext";
import { LanguageProvider } from "./utills/LanguageContext";

function App() {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.AuthReducer?.isLogin);

  useEffect(() => {
    const userData = localStorage.getItem("@user");
    const token = localStorage.getItem("@token");
    // var user = JSON.parse(userData && atob(userData));
    console.log("tokennnnnn", token);
    if (userData != null && token != null) {
      // console.log("sdfsdfsdfseadfasdf", islogin);
      dispatch(getUser(userData));
      dispatch(isLogin(true));
      // dispatch(AuthMiddleware.GeneralType());
    } else {
      dispatch(getUser(null));
      dispatch(isLogin(false));
    }
  }, []);

  return islogin == null ? (
    <></>
  ) : (
    <>
      <LanguageProvider>
        <ThemeProvider>
          <TimezoneProvider>
            <AlertComp />
            <Loading />
            <RouterProvider router={router} />
          </TimezoneProvider>
        </ThemeProvider>
      </LanguageProvider>
    </>
  );
}

export default App;
